import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const StyledButtonBackground = styled.div`
  display: flex;
  width: 48px;
  justify-content: center;
  border-radius: ${token.radiusLarge};
  background: ${token.gray10};
  box-shadow: ${token.elevationStatic}, ${token.elevation2};
  padding: ${token.spacing2};
`;
